<template>

  <div style="height:100%;width:100%">
    <div id="docusign" style="height:100%;position: relative">
      <v-progress-circular
          style="    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);"
        indeterminate
        color="blue"
        size="50"
        width="10"
        class="d-flex justify-center mx-auto align-center"/>
    </div>
  </div>
</template>
<script>


import {getDocuSignFormInstanceToken} from "@/services/docusignService";

export default {
  name: "NewObjectFormDocuSign",
  data() {
    return {
      formData: null,
    };
  },
  methods:{
    async loadDocuSignScript() {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        const jdkUrl = process.env.VUE_APP_DOCUSIGN_JDK;
        script.src = jdkUrl;
        script.type = "text/javascript";
        script.async = true;
        script.onload = () => resolve(window.DocuSign);
        script.onerror = () => reject(new Error("Failed to load DocuSign script"));
        document.head.appendChild(script);
      });
    },
    async loadWebform() {
      const integrationKey = process.env.VUE_APP_DOCUSIGN_INTEGRATION_KEY;
      const webformId = process.env.VUE_APP_DOCUSIGN_EINWILLIGUNG_FORM;
      const {instanceToken,formUrl} = await getDocuSignFormInstanceToken(webformId);
      console.log("instanceToken", instanceToken);
      if(!integrationKey){
        console.error("DocuSign integration key is not set in ENV");
        return;
      }
      try {
        const DocuSign = await this.loadDocuSignScript();
        const { loadDocuSign } = DocuSign;
        const docusign = await loadDocuSign(integrationKey);
        const webFormOptions = {

          instanceToken: instanceToken,
          hideProgressBar: false,
          styles: {
            fontColor: "black",
          },
          iframeStyles: {
            minHeight: "800px",
          },
          autoResizeHeight: true,
        };
        const webFormWidget = docusign.webforms({
          url: formUrl,
          options: webFormOptions,
        });
        webFormWidget.on("ready", (event) => {
          console.log("debug form loaded", event);
        });

        webFormWidget.on("error", (event) => {
          console.error("debug form error", event);
        });
        webFormWidget.on("submitted", (event) => {
        // event = { type: \"submitted\", envelopeId: \"abcd1234\" };
        console.log("debug form submitted", event);

          webFormWidget.on("signingReady", (event) => {
          // event = { type: \"submitted\", envelopeId: \"abcd1234\" };
          console.log("debug form signingReady", event);
        });

        webFormWidget.on("sessionEnd", (event) => {
        // event = { type: \"sessionEnd\", sessionEndType: \"sessionTimeout\" };
        // event = {
        //   type: 'sessionEnd',
        //   sessionEndType: \"signingResult\",
        //   signingResultType: \"signing_complete\",
        //   returnUrl: \"bigcorp.com\",
        //   envelopeId: \"abcd1234\",
        // };
        // event = { type: \"sessionEnd\", sessionEndType: \"remoteSigningInitiated\", envelopeId: \"abcd1234\" };
        console.log("debug form signingResult", event);

        let returnUrl = event.returnUrl;

          let iframe = document.createElement("iframe");
          iframe.src = returnUrl; // Set the source URL for the iframe
          iframe.style.width = "100%"; // Set the width of the iframe
          iframe.style.height = "100%"; // Set the height of the iframe
          iframe.style.border = "none"; // Remove the border for a clean look
          iframe.style.minHeight="800px";
          let docuSignContainer = document.getElementById("docusign");
          docuSignContainer.innerHTML = ""; // Clear any existing content in the container
          docuSignContainer.appendChild(iframe); // Append the iframe to the container

      });

      });


        webFormWidget.mount("#docusign");
      } catch (error) {
        console.error("Error loading DocuSign webform:", error);
      }
    },
  },
  async mounted() {
    await this.loadWebform();
  },
}
</script>
